import { Component, Inject, OnInit, Renderer2, DOCUMENT } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { BrandingService, CompanyBranding, MetaService } from "common";
import { catchError } from "rxjs/operators";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { EMPTY } from "rxjs";

@UntilDestroy()
@Component({
    selector: "ifm-root",
    templateUrl: "./app.component.html",
    standalone: false
})
export class AppComponent implements OnInit {
  brandingData: any;

  constructor(
    private router: Router,
    private titleService: Title,
    private metaService: MetaService,
    private brandingService: BrandingService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
  ) {
    this.setDOMElements();
  }

  ngOnInit(): void {
    this.initBranding();
  }

  private initBranding() {
    this.brandingService.getBranding$()
      .pipe(
        untilDestroyed(this),
        catchError((error) => {
          console.error(error);
          return EMPTY;
        })
      ).subscribe(data => {
        this.initBrandingTheme(data);
        this.setDOMElements();
      });
  }

  private initBrandingTheme(brandingData: CompanyBranding) {
    if (brandingData?.colorSchema === 'levelesq') {
      this.renderer.setAttribute(
        this.document.body,
        'class',
        'theme-level-esq'
      );
    }
  }

  private setDOMElements(): void {
    this.titleService.setTitle("Business Financing | LevelEsq");

    this.metaService.createMetaTag(
      "description",
      `Welcome to your account. You can access information about your business with us here.`
    );
    // TODO[init] levelesq?
    this.metaService.createAlternateURL("https://portal.levelesq.com");
  }
}
